import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { colors } from '../../colors'
import { NavBar } from '../../components/navbar'
import { not_found } from '../../assets'

const NotFound = () => {
  return (
    <Container>
      {/* <NavBar /> */}

      <InnerContainer>
        <div>
        <NotFoundText>
          <span>
            400 error
          </span>
          <h1>Page not found...</h1>
          <h5>Sorry, the page you are looking for doesn't exist or has been moved. Try searching our site:</h5>
          <Link to='/' > Go home </Link>
          
        </NotFoundText>
          <img src={not_found} alt='not found' />
        </div>
      </InnerContainer>
      

    </Container>
  )
}

const Container = styled.section`
  width: 100%;
`

const InnerContainer = styled.div`
  width: 80%;
  margin: 0 auto;

  @media screen and (max-width: 600px) {
    width: 90%;
  }

  & > div{
    display: flex;
    justify-content: space-between;
    align-items: center;

    @media screen and (max-width: 600px) {
      padding-top: 50px;
      flex-direction: column;
    }
  }

  &  img{

    @media screen and (max-width: 600px) {
      width: 80%;
    }
  }

`

const NotFoundText = styled.div`

    & > span{
      color: ${colors.secondary};
      font-weight: 600;
    }

    & > h1{
      font-weight: 700;
    }

    & > h5{
      color: #667085;
      margin-bottom: 15px;
    }

    & > a{
      
      font-size: 1.6rem;
    }
`

export {NotFound}